export interface SummaryLanguage {
  value: string;
  label: string;
}

export const fetchLanguagesList = async (): Promise<SummaryLanguage[]> => {
  const url = process.env.GATSBY_OASIS_SUMMARY_LANGUAGE_WRITTEN_IN_URL as string;
  //console.log(url);

  if (!url) {
    throw new Error("Missing env var: GATSBY_OASIS_SUMMARY_LANGUAGE_WRITTEN_IN_URL");
  }

  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to fetch: ${res.statusText}`);
  }

  const raw = await res.json();

  const languages: SummaryLanguage[] = raw
    .filter((item: any) => !item.status || item.status === "APPROVED")
    .map((item: any) => ({
      value: item.id,
      label: item.label,
    }));

  // Adding all languages as extra since its not fetched from API
  return [
    { value: "all-languages", label: "All Languages" },
    ...languages,
  ];
};
